import { Button } from "@mui/material";

const ButtonToolbar = (props) => {
  const { variantStatus = "send", children, ...others } = props;

  const getColor = (item) => {
    switch (item) {
      case "send":
        return "#45C8D0";
        break;
      case "approve":
        return "primary.dark";
        break;
      case "rejected":
        return "#ff3824";
        break;
      case "save":
        return "primary.dark";
        break;
      default:
        return "primary.dark";
    }
  };
  return (
    <Button
      {...others}
      variant={"contained"}
      sx={{
        width: "200px",
        height: "52px",
        backgroundColor: getColor(variantStatus),
        ":hover": {
          backgroundColor: getColor(variantStatus),
        },

        ...others?.sx,
      }}
    >
      {children !== undefined
        ? children
        : variantStatus === "send"
        ? "Dërgo"
        : variantStatus === "approve"
        ? "Aprovo"
        : variantStatus === "save"
        ? "Ruaj"
        : variantStatus === "rejected"
        ? "Refuzo"
        : ""}
    </Button>
  );
};

export default ButtonToolbar;

ButtonToolbar.propTypes = {
  variantStatus: "approve" | "send" | "save" | "rejected",
};
